import { render } from "preact";
import { App } from "./App";
import "@fontsource-variable/nunito-sans/wght.css";
import "./styles.css";

render(<App />, document.getElementById("app")!);
